const
    w = window,
    d = document,
    de = d.documentElement,
    c = process.env.DEBUG ? console.log : () => { },
    ce = console.error;

export {
    w,
    d,
    de,
    c,
    ce,
};